/*=========================================================================================
  File Name: moduleEcommerceActions.js
  Description: Ecommerce Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Floppy from '@/helpers/IndexedDB.js';
export default {
  /*toggleItemInWishList ({ commit }, item) {
    commit('TOGGLE_ITEM_IN_WISH_LIST', item);
  },
  toggleItemInCart ({ getters, commit, dispatch }, item) {
    getters.isInCart(item.objectID) ? commit('REMOVE_ITEM_FROM_CART', item) : dispatch('additemInCart', item);
  },
  additemInCart ({ commit }, item) {

    // Below properties should be added as per requirement from back-end
    // This is added just for demo purpose
    item['quantity'] = 1;
    item['discount_in_percentage'] = Math.floor(Math.random() * 20) + 4;
    item['offers_count'] = Math.floor(Math.random() * 4) + 1;
    item['delivery_date'] = new Date(new Date().getTime() + (Math.random() * 10 * 24 * 60 * 60 * 1000)).toDateString().slice(0, -4);

    commit('ADD_ITEM_IN_CART', item);
  },
  updateItemQuantity ({ commit }, payload) {
    commit('UPDATE_ITEM_QUANTITY', payload);
  },*/

  async init_aplication({dispatch, commit}, payload) {
    try{
      //CONSULTAMOS LA BASE DE DATOS INDEXDB PARA AVERIGUAR SI HAY FORMULARIOS
      const formularios = await Floppy.getAll('formulario');
      if(formularios.length === 0){
        const idForm = await Floppy.save('formulario', {});
        commit('CHANGE_ID_FORM', {idForm, listForms: []});

        //CREAMOS LA PRIMERA PAGINA PARA EL FORMULARIP
        // dispatch('CREATE_PAGE',idForm);
        dispatch('create_page',idForm);

      }else {
        //POR EL MOMENTO TOMAMOS EL PRIMER ELMENTO DE LA LISTA MIENTRAS SE ACOMODA LA LISTA EN LA VISTA PARA QUE EL USUARIO SELECCIONE
        //EL FORMULARIO QUE VA A TRABAJAR

        // commit('CHANGE_ID_FORM', {idForm: '', listForms: formularios});
        commit('CHANGE_ID_FORM', {idForm: formularios[0].key, listForms: formularios});
        // dispatch('CREATE_PAGE',formularios[0].key);
        dispatch('create_page',formularios[0].key);
      }
    }catch(error){

    }
  },
  async create_page({commit, state},payload){
    console.log('create_page create_page ',payload);

    const page = {
      id_form: payload,
      page_name: 'Pagina ' + state.page,
      questions: []
    }
     const id_page = await Floppy.save('pages', page);
     commit('CHANGE_PAGE_ID',id_page);
     await Floppy.save('pages',page);
  },

  async add_question({commit, dispatch}) {

  }
};
